window.globalState = {
  phoneValue: "8184713166",
};

(function () {
  // const dom = document.querySelector('#' + id);
  const cookieMap = Object.fromEntries(
    document.cookie.split(";").map((i) => {
      const [k, ...v] = i.split("=");
      return [k.trim(), v.join("=").trim()];
    })
  );

  window.fbp = cookieMap["_fbp"] || "";

  function getNewFbc() {
    const alphaBate = "AbCdEfGhIjKlMnOpQrStUvWxYz1234567890".split("");

    const version = "fb";
    const subdomainIndex = location.host.split(".").length - 1;
    const creationTime = Date.now();
    const fbclid =
      new URLSearchParams(location.search).get("fbclid") ||
      Array.from({ length: 36 })
        .fill(0)
        .map(() => alphaBate[Math.floor(Math.random() * alphaBate.length)])
        .join("");
    const newFbc = `${version}.${subdomainIndex}.${creationTime}.${fbclid}`;
    document.cookie = `_fbc=${newFbc}; path=/`;
  }

  window.fbc = cookieMap["_fbc"] || getNewFbc();

  window.OmegaCommon.client_ip_address = "";
  fetch("//api.ipify.org")
    .then((res) => res.text())
    .then((ip) => {
      window.OmegaCommon.client_ip_address = ip;
    })
    .catch(() => void 0);
  window.OmegaCommon.client_user_agent = window?.navigator?.userAgent || "";
  window.OmegaCommon.fbc = fbc;
  window.OmegaCommon.fbp = fbp;
  window.OmegaCommon.em = "";
  window.OmegaCommon.ph = "";
  Omega.trackEvent("ibt_silver_bullet_multi_counry_landing_init_view_sw", "", {
    ...window.OmegaCommon,
  });
})();

var baseUrl = "//whatsapp-driver.didiglobal.com";

// 替换app下载地址
var oneLink = (function () {
  var params = {};
  var search = location.search;
  if (search) {
    search = search.slice(1);
    var searchArr = search.split("&");
    searchArr.forEach(function (e) {
      var key = e.split("=")[0];
      var value = e.split("=")[1];
      params[key] = value;
    });
  }
  var newParams = transformParams(params);
  var newSearch = "";
  for (var key in newParams) {
    newSearch += `${key}=${newParams[key]}&`;
  }
  var oneLink = `https://br-rides-driver.onelink.me/IY6B?${newSearch}`;
  $(".app-download-link").attr("href", oneLink);
  $(".app-download-link").on("click", function () {
    Omega.trackEvent("ibt_gd_app_download_ck", "", {
      k: "click",
      v: "download",
      tab: "app_download_page",
      ...OmegaCommon,
    });
    Omega.trackEvent(
      "ibt_silver_bullet_multi_counry_landing_onelink_ck",
      "",
      {
        ...window.OmegaCommon,
      }
    );
  });
  return oneLink;
})();

$(".mainscreen-3-mobile-position")
  .children()
  .each(function (index, element) {
    $(element).on("click", function () {
      $(".mainscreen-3-mobile").removeClass("position-1");
      $(".mainscreen-3-mobile").removeClass("position-2");
      $(".mainscreen-3-mobile").removeClass("position-3");
      $(".mainscreen-3-mobile").addClass("position-" + (index + 1));
    });
  });
$("label[tabindex='0']").on("keydown", function (event) {
  if (event.key === "Enter") {
    var forId = $(event.target).attr("for");
    $(`#${forId}`).trigger("click");
  }
});

$("input:radio[name='vehicle']").on("click", function (event) {
  var checkValue = $("input:radio[name='vehicle']:checked").val();
  if (checkValue === "yes") {
    $("#driver-radio-group").removeClass("hide");
  } else {
    $("#driver-radio-group").addClass("hide");
  }
});

$(".phone-input-input").formatInput({
  formatArr: [2, 4, 4],
  delimiter: " ",
});

function changeProgress(step) {
  $(".complited-progress").animate(
    {
      "--progress": step,
    },
    {
      duration: 500,
      step(val) {
        $(".complited-progress").attr("style", `--progress: ${val};`);
      },
    }
  );
}

$("#already-signup-ck").on("click", function () {
  Omega.trackEvent("ibt_gd_already_signup_ck", "", {
    k: "click",
    v: "signup",
    tab: "number_submit_page",
    ...OmegaCommon,
  });
});

$("#step-1-btn").on("click", function (event) {
  var pass = true;
  globalState.vehicleValue = $("input:radio[name='vehicle']:checked").val();
  if (globalState.vehicleValue === undefined) {
    $("#vehicle-radio-group").shake();
    Omega.trackEvent("tech_ibt_diy_error", "sb-driver-signup-A", {
      k: "vehicleValue_error",
      v: globalState.vehicleValue,
    });
    pass = false;
  }
  globalState.driverValue = $("input:radio[name='driver']:checked").val();
  if (
    globalState.vehicleValue === "yes" &&
    globalState.driverValue === undefined
  ) {
    $("#driver-radio-group").shake();
    Omega.trackEvent("tech_ibt_diy_error", "sb-driver-signup-A", {
      k: "driverValue_error",
      v: globalState.driverValue,
    });
    pass = false;
  }
  globalState.originPhoneValue = $(".phone-input-input").val();
  globalState.phoneValue = $(".phone-input-input").val().replace(/ /g, "");
  if (globalState.phoneValue.length < 1) {
    $(".phone-input").shake();
    Omega.trackEvent("tech_ibt_diy_error", "sb-driver-signup-A", {
      k: "phoneValue_length_error",
      v: globalState.phoneValue,
    });
    pass = false;
  }
  globalState.accepted = $("#terms-and-conditions:checked").val();
  if (globalState.accepted === undefined) {
    $(".select-checkbox").shake();
    Omega.trackEvent("tech_ibt_diy_error", "sb-driver-signup-A", {
      k: "accepted_error",
      v: globalState.accepted,
    });
    pass = false;
  }
  if (!pass) {
    return;
  }
  OmegaCommon.ph = OmegaCommon.phone =
    "+55".replace("+", "") + globalState.phoneValue;
  /** 开始埋点 */
  if (globalState.vehicleValue === "yes") {
    if (globalState.driverValue === "self") {
      Omega.trackEvent("ibt_gd_choose_have_car_self_submit_ck", "", {
        k: "click",
        v: "havecar_self",
        tab: "number_submit_page",
        ...OmegaCommon,
      });
    } else {
      Omega.trackEvent("ibt_gd_choose_have_car_others_submit_ck", "", {
        k: "click",
        v: "havecar_others",
        tab: "number_submit_page",
        ...OmegaCommon,
      });
    }
  } else {
    Omega.trackEvent("ibt_gd_choose_no_car_submit_ck", "", {
      k: "click",
      v: "nocar",
      tab: "number_submit_page",
      ...OmegaCommon,
    });
  }
  Omega.trackEvent(
    "ibt_silver_bullet_multi_counry_landing_baseinfo_next_ck",
    "",
    {
      identity:
        globalState.vehicleValue === "yes"
          ? globalState.driverValue === "self"
            ? 3
            : 2
          : 1,
      ...window.OmegaCommon,
    }
  );
  /** 埋点结束 */
  changeProgress(0.25);
  [$(".mainscreen-3"), $(".mainscreen-4"), $(".mainscreen-5")].forEach((e) => {
    e.animate(
      {
        opacity: 0,
      },
      500,
      function () {
        e.hide();
      }
    );
  });
  $(".mainscreen-1-1-3-page").animate(
    {
      opacity: 0,
    },
    250,
    step2bind
  );
});
search = "product=2&country=BR";
retryFetch(`${baseUrl}/city/getCityList?${search}`)
  .then((response) => {
    return response.json();
  })
  .then((data) => {
    console.debug("[Cities]", data);
    cityList = data.data;
    var $optionList = $(".option-list");
    if ($optionList) {
      $optionList.empty();
      cityList.forEach((city) => {
        $optionList.append(
          `<div class="option-item" data-id="${city.value}">${city.text}</div>`
        );
      });
      $(".option-item").on("click", function (event) {
        globalState.cityId = $(this).data("id");
        $(".mainscreen-1-1-3-1-2-0").val($(event.target).text());
        $(".mainscreen-1-1-3-1-2").removeClass("show-list");
      });
    }
  });

var cityList = [
  {
    text: "Aguascalientes",
    value: 52010100,
  },
  {
    text: "Colima",
    value: 52060100,
  },
];

function step2bind() {
  $(".mainscreen-1-1-3-page").html(
    `
  <h3 class="mainscreen-1-1-3-1-text-0">Insira seus dados para iniciar seu cadastro</h3>
  <div class="mainscreen-1-1-3-1-1">
      <input class="mainscreen-1-1-3-1-1-0" type="text" placeholder="Nome">` +
      // 
      `
  </div>` +
      // 
      `
  <div class="select mainscreen-1-1-3-1-2-BR">
      <input id="sex-type" class="select-input" readonly type="text"
          placeholder="Gênero">
      <div class="sex-option-list" id="sex-type-option-list">
          <div class="sex-option-item" data-id="0">Masculino</div>
          <div class="sex-option-item" data-id="1">Feminino</div>
          <div class="sex-option-item" data-id="2">Outros</div>
      </div>
  </div>` +
      // 
      `
  <div class="mainscreen-1-1-3-1-2">
      <input class="mainscreen-1-1-3-1-2-0" type="text" placeholder="Cidade">
      <div class="option-list">
      </div>
  </div>
  <button class="submit-btn" id="step-2-btn">
      <span class="submit-btn-text">Avançar</span>
  </button>
  `
  );
  $(".option-list").html(
    cityList
      .map((e) => {
        return `<div class="option-item" data-id="${e.value}">${e.text}</div>`;
      })
      .join("")
  );
  function ShowAllOptionList() {
    $(".option-item").each(function (index, element) {
      $(element).show();
    });
  }
  $(".mainscreen-1-1-3-page").animate(
    {
      opacity: 1,
    },
    250
  );
  $(".mainscreen-1-1-3-1-2-0").on("focus", function () {
    $(".mainscreen-1-1-3-1-2").addClass("show-list");
  });
  $(".mainscreen-1-1-3-1-2-0").on("blur", function () {
    // 检查一下 如果匹配只剩一个就回填完整信息
    // 如果回填大于一个就清空输入
    var matchItems = cityList.filter((e) => {
      return e.text.toLowerCase().indexOf($(this).val().toLowerCase()) !== -1;
    });
    if (matchItems.length === 1) {
      var [{ text, value }] = matchItems;
      globalState.cityId = value;
      $(this).val(text);
    } else {
      const matchItem = matchItems.find(
        ({ value }) => `${value}` === `${globalState.cityId}`
      );
      if (matchItem) {
        $(this).val(matchItem.text);
      } else {
        $(this).val("");
        ShowAllOptionList();
      }
    }
    $(".mainscreen-1-1-3-1-2").removeClass("show-list");
  });
  $("#sex-type").on("focus", function () {
    $(".mainscreen-1-1-3-1-2-BR").addClass("show-list");
  });
  $("#sex-type").on("blur", function () {
    $(".mainscreen-1-1-3-1-2-BR").removeClass("show-list");
  });
  $(".sex-option-item").on("click", function (event) {
    globalState.sexId = Number.parseInt($(this).data("id"));
    $("#sex-type").val($(event.target).text());
    $(".mainscreen-1-1-3-1-2-BR").removeClass("show-list");
  });
  Omega.trackEvent("ibt_gd_basic_info_page_sw", "", {
    k: "access",
    tab: "basic_info_page",
    ...OmegaCommon,
  });
  function onselect(event) {
    globalState.cityId = $(this).data("id");
    $(".mainscreen-1-1-3-1-2-0").val($(event.target).text());
    $(".mainscreen-1-1-3-1-2").removeClass("show-list");
  }
  $(".option-item").on("mousedown", onselect);
  $(".option-item").on("touchstart", onselect);
  $(".mainscreen-1-1-3-1-2-0").on("input", function (event) {
    var input = $(event.target).val();
    $(".option-item").each(function (index, element) {
      if ($(element).text().toLowerCase().includes(input.toLowerCase())) {
        $(element).show();
      } else {
        $(element).hide();
      }
    });
  });
  $("#step-2-btn").on("click", function () {
    globalState.name = $(".mainscreen-1-1-3-1-1-0").val();
    globalState.lastname = $(".mainscreen-1-1-3-1-1-1").val();
    globalState.city = $(".mainscreen-1-1-3-1-2-0").val();
    var pass = true;
    Omega.trackEvent(
      "ibt_silver_bullet_multi_counry_landing_otherinfo_next_ck",
      "",
      {
        name: `${globalState.name} ${globalState.lastname}`,
        city: globalState.city || "",
        ...window.OmegaCommon,
      }
    );
    if (!globalState.name || globalState.name.length < 1) {
      $(".mainscreen-1-1-3-1-1-0").shake();
      Omega.trackEvent("tech_ibt_diy_error", "sb-driver-signup-A", {
        k: "name_length_error",
        v: globalState.name,
      });
      pass = false;
    }
    // 
    if (typeof globalState.sexId === "undefined") {
      $(".mainscreen-1-1-3-1-2-BR").shake();
      Omega.trackEvent("tech_ibt_diy_error", "sb-driver-signup-A", {
        k: "sexId_error",
        v: globalState.sexId,
      });
      pass = false;
    }
    // 
    if (!globalState.city || globalState.city.length < 1) {
      $(".mainscreen-1-1-3-1-2-0").shake();
      Omega.trackEvent("tech_ibt_diy_error", "sb-driver-signup-A", {
        k: "city_length_error",
        v: globalState.city,
      });
      pass = false;
    }
    if (!pass) {
      return;
    }
    Omega.trackEvent("ibt_gd_basic_info_submit_ck", "", {
      k: "click",
      v: "basic_info",
      tab: "basic_info_page",
      ...OmegaCommon,
    });
    changeProgress(0.5);
    $(".mainscreen-1-1").animate(
      {
        opacity: 0,
      },
      250,
      step3bind
    );
  });
}

function step3bind() {
  $(".mainscreen-1").addClass("hide-people");
  $(".mainscreen-1-1").attr(
    "style",
    `height: ${$(".mainscreen-1-1").height()}px;`
  );
  $(".mainscreen-1-1").html(`
    <div class="mainscreen-1-1-page-0 step3">
      <div class="mainscreen-1-1-page-0-login-sdk-box"> 
        <iframe id="login-sdk" class="mainscreen-1-1-page-0-login-sdk" width="435px" height="300px"></iframe>
      </div>
    </div>
  `);
  $(".mainscreen-1-1").animate(
    {
      opacity: 1,
    },
    250
  );
  $("#login-sdk").attr(
    "srcdoc",
    `<!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <meta http-equiv="X-UA-Compatible" content="ie=edge">
        <title>Document</title>
        <style>
          div.login-action-sheet-wrapper .action-sheet-mask {
            background-color: transparent;
          }
          div.login-wrapper.add-trans {
              transition: none;
              -webkit-transform: none;
            }
          div.login-wrapper .slot {
              transition: none;
              -webkit-transform: none;
              padding: 0;
          
              bottom: auto;
              box-shadow: none;
              -webkit-box-shadow: none;
          }
          div.login-wrapper .title {
              color: #ff9506;
              font-weight: bold;
          }
          div.login-wrapper .describe-wrapper {
            color: #ff9506;

          }
          div.login-wrapper .describe-wrapper .describe.cell-des,
          div.login-wrapper .describe {
            color: #ff9506;
          }
          div.login-wrapper .login-code .code-wrapper .code-describe {
            color: #ff9506;
          }
          div.login-wrapper .login-code .code-cant-get {
            height: auto;
          }
          .loading{
            width: 150px;
            height: 15px;
            margin: 0 auto;
            margin-top:100px;
        }
        .loading span{
            display: inline-block;
            width: 15px;
            height: 100%;
            margin-right: 5px;
            border-radius: 50%;
            background: #ff9506;
            -webkit-animation: load 1.04s ease infinite;
            animation: load 1.04s ease infinite;
        }
        .loading span:last-child{
            margin-right: 0px; 
        }
        @-webkit-keyframes load{
            0%{
                opacity: 1;
            }
            100%{
                opacity: 0;
            }
        }
        @keyframes load{
          0%{
              opacity: 1;
          }
          100%{
              opacity: 0;
          }
      }
        .loading span:nth-child(1){
            -webkit-animation-delay:0.13s;
            animation-delay:0.13s;
        }
        .loading span:nth-child(2){
            -webkit-animation-delay:0.26s;
            animation-delay:0.26s;
        }
        .loading span:nth-child(3){
            -webkit-animation-delay:0.39s;
            animation-delay:0.39s;
        }
        .loading span:nth-child(4){
            -webkit-animation-delay:0.52s;
            animation-delay:0.52s;
        }
        .loading span:nth-child(5){
            -webkit-animation-delay:0.65s;
            animation-delay:0.65s;
        }
        </style>
    </head>
    <body>
        <div class="center">
          <div class="loading">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <script src="//static.didiglobal.com/common-biz/global-login/2.1.7/login.global.min.js"></script>
        <script>
          login.setConfig({
            /* 基础参数 */
            appid: 200020 /* 非微信、支付宝的浏览器环境 */,
            role: 2 /* 角色: 司机 */,
            city_id: 0,
            lang: 'pt-BR',
            country_calling_code: '+55',
            country_id: 76,
            canonical_country_code: 'BR',
            styleObj: {
              /* 自定义按钮及法律icon样式 */
              btn: {
                disableColor: "#999999",
                activeColor: "#ffffff",
                bgColor: "#ff9506",
              },
              law: {
                color: "#2697FF",
                iconBlue: true,
                marginRight: "12px"
              }
            }
          });
          var loginCallback = window.parent.loginCallback
          login.checkPhone("${globalState.phoneValue}", loginCallback.success, loginCallback.fail)
          var findCount = 0
          var status = 'none'
          var onceFail = false
          setInterval(() => {
            var toast = document.getElementsByClassName('icon remind')[0]
            if (toast) {
              if(status === 'slot' && !onceFail) {
                onceFail = true
                loginCallback.fail("remind-icon:[" + toast.parentNode.textContent + "]")
              }
            } else {
              onceFail = false
            }
          }, 200)
          function resizeHandler() {
              var slotElement = document.getElementsByClassName('slot')[0];
              if (findCount > 10 && status === 'none') {
                  loginCallback.fail("timeout")
              }
              var actionSheet = document.getElementsByClassName('action-sheet')[0];
              if (actionSheet) {
                status = 'action-sheet'
                var lastWidth = actionSheet.offsetWidth;
                var lastHeight = actionSheet.offsetHeight;
                loginCallback.resize(lastWidth, lastHeight);
                var actionSheetInterval = setInterval(function () {
                  element = document.getElementsByClassName('action-sheet')[0];
                  if (!element || status !== 'action-sheet') {
                    clearInterval(actionSheetInterval)
                    return
                  }
                  if (lastWidth === element.offsetWidth && lastHeight === element.offsetHeight)
                      return;
                  loginCallback.resize(element.offsetWidth, element.offsetHeight);
                  lastWidth = element.offsetWidth;
                  lastHeight = element.offsetHeight;
                }, 100);
              }
              if (slotElement) {
                  status = 'slot'
                  var lastWidth = slotElement.offsetWidth;
                  var lastHeight = slotElement.offsetHeight;
                  loginCallback.resize(lastWidth, lastHeight);
                  setInterval(function () {
                      element = document.getElementsByClassName('slot')[0];
                      if (!element || (lastWidth === element.offsetWidth && lastHeight === element.offsetHeight))
                          return;
                      loginCallback.resize(element.offsetWidth, element.offsetHeight);
                      lastWidth = element.offsetWidth;
                      lastHeight = element.offsetHeight;
                  }, 100);
                  var codeRetry = document.getElementsByClassName('code-retry')[0];
                  if (codeRetry) {
                      codeRetry.addEventListener('click', function (event) {
                        if(event.target.className === 'code-retry') {
                          loginCallback.trackEvent('ibt_gd_passport_submit_again_ck', '', {
                            k: 'click',
                            v: 'submit_again',
                            tab: 'passport_verif_code_page'
                          })
                        }
                      })
                  }
              } else {
                  findCount++;
                  setTimeout(function () {
                      resizeHandler();
                  }, 1000);
              }
          }
          resizeHandler();
          function ignoreSetEmail() {
            var setEmail = document.getElementsByClassName('login-setEmail')[0]
            if (setEmail) {
              var ignore = setEmail.getElementsByClassName("ignore")[0]
              if (ignore) {
                ignore.click()
              }
            } else {
              setTimeout(function () {
                ignoreSetEmail()
              }, 100)
            }
          }
          ignoreSetEmail()
        </script>
    </body>
  </html>
    `
  );
  Omega.trackEvent("ibt_gd_passport_verif_code_page_sw", "", {
    k: "access",
    tab: "passport_verif_code_page",
    ...OmegaCommon,
  });
  window.loginCallback = {
    success(loginRes) {
      var ticket = loginRes.ticket;
      OmegaCommon.ticket = ticket;
      Omega.trackEvent("ibt_gd_passport_verif_code_submit_ck", "", {
        k: "click",
        v: "verif_submit",
        tab: "passport_verif_code_page",
        ...OmegaCommon,
      });
      Omega.trackEvent(
        "ibt_silver_bullet_multi_counry_landing_passport_registration_ck",
        "",
        {
          ...window.OmegaCommon,
        }
      );
      globalState.ticket = ticket;
      var search = location.search;
      if (/^\?/.test(search)) {
        search = search.slice(1);
      }
      search = `ticket=${ticket}` + (search ? `&${search}` : "");
      fetch(`${baseUrl}/driverInfo/funnel/status?${search}`)
        .then((res) => res.json())
        .then((res) => {
          if (res.errno === 0) {
            if (res.data.result === "regular") {
              res.data.url = null;
            }
            if (typeof res.data.url === "string" && res.data.url.length > 0) {
              window.location.href = res.data.url;
              return;
            } else if (res.data.result === "passport") {
              changeProgress(0.75);
              $(".mainscreen-1-1").animate(
                {
                  opacity: 0,
                },
                250,
                step4bind
              );
            } else {
              changeProgress(1);
              $(".mainscreen-1-1").animate(
                {
                  opacity: 0,
                },
                250,
                step5bind
              );
            }
          } else {
            alertDiv(res.errmsg || "Falhou ao conectar com o servidor");
          }
        })
        .catch((err) => {
          Omega.trackEvent("tech_ibt_ajax_failed", "sb-driver-signup-A", {
            column: err.stack,
            message: err.message,
          });
          alertDiv(err || "Falhou ao conectar com o servidor");
        });
    },
    fail(...args) {
      if (args[0].indexOf("remind-icon:") === 0) {
        Omega.trackEvent("ibt_gd_passport_verif_submit_error_sw", "", {
          k: "show",
          v: "verif_error",
          tab: "passport_verif_code_page",
          ...OmegaCommon,
        });
        Omega.trackEvent("tech_ibt_diy_error", "sb-driver-signup-A", {
          errmsg: args[0],
        });
        return;
      }
      // refresh
      console.log(args);
      alertDiv("Algo deu errado, tente novamente mais tarde.").then(() => {
        window.location.reload();
      });
    },
    resize(width, height) {
      $("#login-sdk").height(height);
    },
    trackEvent(...args) {
      args[2] = {
        ...(args[2] || {}),
        ...OmegaCommon,
      };
      Omega.trackEvent(...args);
    },
  };
}

function sendInputError() {
  Omega.trackEvent("ibt_gd_curp_input_error_sw", "", {
    k: "show",
    v: "input_error",
    tab: "curp_page",
    ...OmegaCommon,
  });
}

function step4bind() {
  $(".mainscreen-1-1").attr(
    "style",
    `height: ${$(".mainscreen-1-1").height()}px;`
  );
  $(".mainscreen-1-1").html(`
  <div class="mainscreen-1-1-page-0">
    <div class="mainscreen-1-1-page-0-text-0">OLÁ, FUTURO PARCEIRO</div>
    <h1 class="mainscreen-1-1-page-0-text-1-mobile">Falta pouco</h1>
    <h1 class="mainscreen-1-1-page-0-text-1 hide-mobile">Falta pouco</h1>
    <div class="mainscreen-1-1-page-0-text-2 hide-mobile">Por favor, informe seu CPF</div>
    <div class="mainscreen-1-1-page-0-text-2-mobile">Por favor, informe seu CPF</div>
    <div class="mainscreen-1-1-page-1-text-3">
        <input maxlength="14" class="mainscreen-1-1-page-1-text-3-0" id="curp-input" type="text" placeholder="CPF"/>
    </div>
    <div class="mainscreen-1-1-page-0-text-4">
       * Não sabe qual é seu CPF?  <a id="curp-lookup-ck" target="_blank" href="https://www.gov.br/receitafederal/pt-br">Clique aqui</a>
    </div>
    <button class="submit-btn" id="step-3-btn">
      <span class="submit-btn-text">Concluir</span>
    </button>
  </div>
  `);
  $(".mainscreen-1-1-page-1-text-3-0").toUpperCase();
  $("#curp-input").formatInput({
    formatArr: "xxx.xxx.xxx-xx".split(/[^x]/).map((x) => x.length),
    delimiter: "xxx.xxx.xxx-xx".replace(/x/g, "").split(""),
  });
  $("#curp-lookup-ck").on("click", function () {
    Omega.trackEvent("ibt_gd_curp_lookup_ck", "", {
      k: "click",
      v: "lookup",
      tab: "curp_page",
      ...OmegaCommon,
    });
  });
  $(".mainscreen-1-1").animate(
    {
      opacity: 1,
    },
    250
  );
  Omega.trackEvent("ibt_gd_curp_page_sw", "", {
    k: "access",
    tab: "curp_page",
    ...OmegaCommon,
  });
  var clickHold = false;
  function updateClickHold(value) {
    clickHold = value;
    if (clickHold) {
      window.clearTimeout(updateClickHold["resetTimeout"]);
      updateClickHold["resetTimeout"] = window.setTimeout(() => {
        updateClickHold(false);
      }, 5000);
    }
  }
  $("#step-3-btn").on("click", function () {
    if (clickHold) return;
    updateClickHold(true);
    // 
    globalState.curp = $(".mainscreen-1-1-page-1-text-3-0").val() || "";
    globalState.curp = globalState.curp.replace(/[.-]/g, "");
    var pass = true;
    if (globalState.curp.length !== 11) {
      $(".mainscreen-1-1-page-1-text-3-0").shake();
      Omega.trackEvent("tech_ibt_diy_error", "sb-driver-signup-A", {
        k: "curp_length_error",
        v: globalState.curp,
      });
      pass = false;
    }
    // 
    if (!pass) {
      updateClickHold(false);
      return;
    }
    var search = location.search;
    if (/^\?/.test(search)) {
      search = search.slice(1);
    }
    search = `ticket=${globalState.ticket}` + (search ? `&${search}` : "");
    fetch(`${baseUrl}/driverInfo/funnel/basicInfo?${search}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        identity:
          globalState.vehicleValue === "yes"
            ? globalState.driverValue === "self"
              ? 3
              : 2
            : 1,
        phoneNumber:
          "+55".replace("+", "") +
          globalState.phoneValue,
        // 
        sex: globalState.sexId,
        name: globalState.name,
        // 
        city: globalState.cityId,
        idNo: globalState.curp,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.errno === 0) {
          Omega.trackEvent("ibt_gd_curp_submit_ck", "", {
            k: "click",
            v: "submit",
            tab: "curp_page",
            ...OmegaCommon,
          });
          var targetUrl = (res.data || {}).url;
          if (typeof targetUrl === "string" && targetUrl.length > 0) {
            window.location.href = targetUrl;
            return new Promise((res) => setTimeout(res, 1000));
          }
          changeProgress(1);
          $(".mainscreen-1-1").animate(
            {
              opacity: 0,
            },
            250,
            step5bind
          );
        } else if (res.errno === 500 || res.errno === 30003) {
          doOnce(sendInputError);
          Omega.trackEvent("tech_ibt_ajax_failed", "sb-driver-signup-A", {
            k: "basicInfo-500",
            res,
          });
          $(".mainscreen-1-1-page-1-text-3-0").shake();
          alertDiv(res.errmsg || "Falhou ao conectar com o servidor");
        } else {
          doOnce(sendInputError);
          Omega.trackEvent("tech_ibt_ajax_failed", "sb-driver-signup-A", {
            k: "basicInfo-other",
            res,
          });
          alertDiv(res.errmsg || "Falhou ao conectar com o servidor");
        }
      })
      .catch((err) => {
        Omega.trackEvent("tech_ibt_ajax_failed", "sb-driver-signup-A", {
          column: err.stack,
          message: err.message,
        });
        console.log(err);
        alertDiv("Falhou ao conectar com o servidor");
      })
      .finally(() => {
        updateClickHold(false);
      });
  });
}

function step5bind() {
  $(".mainscreen-1-1").attr(
    "style",
    `height: ${$(".mainscreen-1-1").height()}px; `
  );
  $(".mainscreen-1").addClass("thankyou-bg");
  $(".mainscreen-1-1").html(`
    <div class="mainscreen-1-1-page-2">
      <div class="mainscreen-1-1-page-2-0"></div>
      <div class="mainscreen-1-1-page-2-1">
        <h1 class="mainscreen-1-1-page-2-1-text-0">
          <span>Tudo pronto!</span><br/><span>Baixe o app para começar</span>
        </h1>
        <div class="mainscreen-1-1-page-2-1-text-1">
          <div class="Thankyoupagemobile"></div>
        </div>
        <div class="download mainscreen-1-1-page-2-1-download-0">
          <div class="download-0"></div>
          <a class="app-download-link" href="${oneLink}">
            <div class="download-1"></div>
          </a>
            <div class="download-2"></div>
          <a class="app-download-link" href="${oneLink}">
            <div class="download-3"></div>
          </a>
          <div class="download-4"></div>
          <div class="download-5">
            <div class="down-icon-o"></div>
          </div>
        </div>
      </div>
      <div class="mainscreen-1-1-page-2-2"></div>
    </div>
  `);
  $(".app-download-link").off("click")
  $(".app-download-link").on("click", function () {
    Omega.trackEvent("ibt_gd_app_download_ck", "", {
      k: "click",
      v: "download",
      tab: "app_download_page",
      ...OmegaCommon,
    });
    Omega.trackEvent(
      "ibt_silver_bullet_multi_counry_landing_onelink_ck",
      "",
      {
        ...window.OmegaCommon,
      }
    );
  });
  $(".mainscreen-1-1").animate(
    {
      opacity: 1,
    },
    250
  );
  Omega.trackEvent("ibt_gd_app_download_page_sw", "", {
    ...OmegaCommon,
    k: "access",
    tab: "app_download_page",
  });
}
